import { AuthSplitLayout } from '../components/auth/layout/AuthSplitLayout';
import { RegisterLeftPanel } from '../components/auth/register/RegisterLeftPanel';
import { RegisterRightPanel } from '../components/auth/register/RegisterRightPanel';

/**
 * Split-screen register page with form on left and branding on right.
 */
export default function RegisterPage() {
  return (
    <AuthSplitLayout
      left={<RegisterLeftPanel />}
      right={<RegisterRightPanel />}
    />
  );
}
